import { DeviceSelector, Logo } from '../components'
import { useAccountContext, useAppContext } from '../contexts'

export function DeviceListController() {
  const { selectedDevice, selectDeviceLocally } = useAccountContext()
  const { showCharts, showBatteryCharts, setShowBatteryCharts, setCurrentDate } = useAppContext()

  function triggerRefresh() {
    if (showCharts) {
      setCurrentDate(new Date())
    }
  }

  return (
    <>
      <div className="w-[150px]">
        <Logo shrink={true} />
      </div>
      <button
        className={showCharts ? tailwind.buttonEnabled : tailwind.buttonDisabled}
        type="button"
        disabled={!showCharts}
        onClick={triggerRefresh}
      >
        Refresh Charts
      </button>
      <button
        className={showCharts ? tailwind.buttonEnabled : tailwind.buttonDisabled}
        type="button"
        disabled={!showCharts}
        onClick={() => {
          setShowBatteryCharts(!showBatteryCharts)
        }}
      >
        {showBatteryCharts ? 'Show Charts' : 'Show Battery'}
      </button>
      <div className={tailwind.deviceSelector}>
        <DeviceSelector
          selectedDevice={selectedDevice}
          setSelectedDevice={(sigfoxId: string) => {
            selectDeviceLocally(sigfoxId)
          }}
        />
      </div>
    </>
  )
}

const tailwind = {
  deviceSelector: 'float-left min-w-[150]',
  buttonEnabled:
    'bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded focus:outline-none focus:shadow-outline mb-1',
  buttonDisabled: 'bg-gray-400 text-white font-bold py-1 px-4 rounded focus:outline-none focus:shadow-outline mb-1',
}
